<template>
  <!-- 发送商品详情-->
  <div>
    <div ref="sendOrder" class="sendOrder">
      <div class="orderDetail">
        <div class="order">
          注文書番号:
          <a
            target="_blank"
            :href="
              'https://www.rakumart.com/api/ordno.php?type=3&ordno=' +
              detail.ordno
            "
          >
            {{ detail.ordno }}
          </a>
        </div>
        <div class="detail">
          <div class="flexs">
            <a
              :href="`https://www.rakumart.com/index.php?mod=goods&act=${detail.type}&id=${detail.iid}`"
              target="_blank"
            >
              <img :src="detail.pic" alt="" />
            </a>
          </div>
          <div class="colorSize">
            <p :title="detail.psize">サイズ：{{ detail.psize }}</p>
            <p :title="detail.color">カラー：{{ detail.color }}</p>
          </div>
          <div style="flex: 1; line-height: 40px; text-align: center">
            ¥{{ detail.price }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },

  data() {
    return {};
  },
  computed: {
    detail() {
      console.log(this.message);
      return JSON.parse(this.message.payload.description);
    },
  },
  methods: {},
};
</script>
<style lang='scss' scoped>
.orderDetail {
  padding: 5px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  .order {
    margin-bottom: 3px;
    a {
      color: #408d7c;
      text-decoration: underline;
    }
  }
  .detail {
    display: flex;
    height: 40px;
    width: 230px;
    .flexs {
      flex: 1;
      text-align: center;
      img {
        width: 40px;
        height: 40px;
      }
    }
    .colorSize {
      flex: 2;
      line-height: 20px;
      p {
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>